import { useContext } from 'react';
import { ErrorContext } from '../../context/ErrorProvider';

export const useError = () => {
  const { error, setError } = useContext(ErrorContext);

  return {
    error,
    setError,
  };
};
